import { updates } from '../whats-new/updates';

export class Controller {

    /** @ngInject */
    constructor($rootScope, $state, $uibModal, Alert) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    $onInit() {
        this.initRegistration();
        this.initRoles();
        this.initWhatsNew();
    }

    /** @private */
    initRegistration() {
        if (this.reg) {
            this.Alert('success', 'registration.company.created_success');
            this.$state.go('.', {reg: null});
        }
    }

    /** @private */
    initRoles() {

        const role = this.currentCompany.authoritiesConstants;
        this.isActiveCompany= this.currentCompany.companyStatus === 'ACTIVE';
        const roleActive = this.isActiveCompany || role==='READ_ONLY_ADMIN';
        const hasRole = (...roles) => ['SAASPASS_ADMIN', 'SUPER_ADMIN', 'READ_ONLY_ADMIN', ...roles].includes(role);
        const hasRoleView = (...roles) => hasRole(...roles) && roleActive;
        this.canView = {
            'reseller': hasRole(),
            'saaspass-admin': role === 'SAASPASS_ADMIN',
            'directory-services': hasRoleView('ORGANIZATION_ADMIN','SHARING_CENTER_ADMIN'),
            'directory-groups': hasRoleView('ORGANIZATION_ADMIN'),
            'saaspass-users': hasRoleView('SHARING_CENTER_ADMIN'),
            'directory-integration': hasRoleView(),

            'applications-group': hasRoleView('APPLICATION_ADMIN', 'DEVELOPER_ADMIN','SHARING_CENTER_ADMIN') ,
            'applications': hasRoleView('APPLICATION_ADMIN'),
            'software-license-management': hasRole('APPLICATION_ADMIN'),

            'sharing-center': hasRoleView('SHARING_CENTER_ADMIN'),
            'enterprise-password-manager': hasRoleView(),
            'hard-token-management': hasRoleView(),
            'computer-protection': hasRoleView('APPLICATION_ADMIN'),
            'slack-info': hasRoleView(),
            'google-marketplace-instructions': hasRoleView(),
            'google-hangouts-bot': hasRoleView(),
            'custom-app-integration': hasRoleView('DEVELOPER_ADMIN'),
            'idp-authenticators': hasRoleView('DEVELOPER_ADMIN'),
            'saaspass-connect': hasRoleView('DEVELOPER_ADMIN'),
            'saaspass-vpn': hasRoleView('DEVELOPER_ADMIN'),
            'sms-services': hasRoleView(),
            'policies':  hasRoleView(),

            'recovery': hasRoleView(),
            'request-center': hasRoleView(),
            'administrators': hasRoleView(),
            'reports-main': hasRoleView(),
            'corporate-settings': hasRoleView(),
            'license-management': this.licenseInfo && hasRoleView(),
            'domains': hasRoleView(),
        };
    }

    /** @private */
    initWhatsNew() {
        const lastUpdateToWhatsNewSection = new Date(updates[0].date);

        if (this.$rootScope.logCompanyAccessed$) {
            this.$rootScope.logCompanyAccessed$.then(lastSwitchToCompanyMode => {
                if (new Date(lastSwitchToCompanyMode) < lastUpdateToWhatsNewSection) {
                    this.$uibModal.open({component: 'whatsNewAlertModal'}).result
                        .finally(() => this.$rootScope.logCompanyAccessed$ = null)
                }
            })
        }
    }

    isReseller() {
        return this.currentCompany.companyType === 'RESELLER';
    }

    portalActionsRestricted() {
        return this.licenseInfo.licenseStatus == 'UNLICENSED' && this.licenseInfo.portalActionsRestricted;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/landing-page/landing-page.controller.js